import { useState, useEffect } from 'react';

/**
 *
 * 401 will be redirected to login page.
 *
 * @param url
 * @param options
 * @returns {{response: unknown, error: unknown, loading: boolean}}
 */
const useFetch = (url, options) => {
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		let res, json;

		const doFetch = async() => {
			setLoading(true);
			try {
				res = await fetch(url, options);

				if (!res.ok)  {    // Handles Fetch OK response
					throw res;
				}

				json = await res.json();

				if (!signal.aborted) {
					setResponse(json);
				}
			} catch (e) {
				if (e.status === 401) {
					window.location.href = '/login.html?origin_page=/home/';
				}

				if (!signal.aborted) {
					setError(e);
				}
			} finally {
				if (!signal.aborted) {
					setLoading(false);
				}
			}
		};

		doFetch();
		return () => {
			abortController.abort();
		};
	}, []);
	return { response, error, loading, setLoading };
};

export default useFetch;
